var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPollSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.208 7.993v3.174H3.85a.675.675 0 00-.1 1.343l.1.007h9.618a.675.675 0 00.1-1.343l-.1-.007h-.36V7.993h1.525c.29 0 .544.184.637.451l.027.104 1.109 5.756a.677.677 0 01-.565.788l-.1.007H1.576a.674.674 0 01-.675-.695l.01-.099L2.019 8.55A.676.676 0 012.576 8l.107-.008h1.525zM11.601 3.6a.43.43 0 01.43.43v7.203H5.3V4.029c0-.237.192-.429.43-.429h5.87z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollSolid);
export default __webpack_public_path__ + "static/media/PollSolid.126bb916.svg";
export { ForwardRef as ReactComponent };